import { render, staticRenderFns } from "./IntelligenceJDMatch.vue?vue&type=template&id=1404e932&scoped=true"
import script from "./IntelligenceJDMatch.vue?vue&type=script&lang=js"
export * from "./IntelligenceJDMatch.vue?vue&type=script&lang=js"
import style0 from "./IntelligenceJDMatch.vue?vue&type=style&index=0&id=1404e932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1404e932",
  null
  
)

export default component.exports